export const Types = {
  // Insere um anexo
  GET_INSERT_REQUEST: 'attachment/GET_INSERT_REQUEST',
  GET_INSERT_SUCCESS: 'attachment/GET_INSERT_SUCCESS',
  GET_INSERT_FAILURE: 'attachment/GET_INSERT_FAILURE',
};

export const initialState = {
  // Insere um anexo
  attachmentInsertLoading: false,
  attachmentInsertError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Insere um anexo
    case Types.GET_INSERT_REQUEST:
      return { ...state, attachmentInsertLoading: true };
    case Types.GET_INSERT_SUCCESS:
      return {
        ...initialState,
      };
    case Types.GET_INSERT_FAILURE:
      return {
        ...state,
        attachmentInsertLoading: false,
        attachmentInsertError: action.payload,
      };
    default:
      return state;
  }
};

export const Creators = {
  // Insere um anexo
  getAttachmentInsertRequest: data => ({
    type: Types.GET_INSERT_REQUEST,
    payload: data,
  }),
  getAttachmentInsertSuccess: () => ({
    type: Types.GET_INSERT_SUCCESS,
  }),
  getAttachmentInsertFailure: error => ({
    type: Types.GET_INSERT_FAILURE,
    payload: error,
  }),
};
